module.exports = "/assets/0b4e763c4df103791356f6f4e3d9405f.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/TG.png
// module id = 2975
// module chunks = 0